import { ICalcs } from '../constants/queryCreation.interface';

/**
 * iterate calcs list to get all window functions being used
 * @param calcsList
 * @returns all window function used in calcs
 */
export const getAllCalcWFs = (calcsList: ICalcs[]): ICalcs[] => {
  return calcsList.filter((calc) => {
    return (calc?.windowFunctions || []).length > 0;
  });
};
